// SCO-2060: the native shells invoke window.enableNotificationButton() via
// evaluateJavaScript, but the real handler only exists while the lazy-loaded
// AdTracking or WelcomeModal chunk is mounted — a native call landing before
// mount (or after unmount, which used to `delete` the property) threw an
// unhandled "window.enableNotificationButton is not a function". Keep a
// permanent stub on window that records the call; the modals override it on
// mount, consume the recorded call, and restore the stub on unmount.

function enableNotificationButtonStub() {
  window.__pendingEnableNotification = true;
}

export function installEnableNotificationStub() {
  window.enableNotificationButton = enableNotificationButtonStub;
}

// Returns true when a native call arrived while only the stub was listening,
// and clears the flag so it's honored exactly once.
export function consumePendingEnableNotification() {
  const pending = window.__pendingEnableNotification;
  window.__pendingEnableNotification = false;
  return Boolean(pending);
}
